import { DefaultTheme } from 'styled-components';

export const theme: DefaultTheme = {
  background: '#181818',
  itemsBackground: '#242424',
  button: '#808080',
  active: '#686767',
  error: '#e22a2a',
  color: 'white',
  lightColor: '#a0a0a0',
  light: 300,
  bold: 600,
  fontSize: {
    xxs: '1rem',
    xs: '1.2rem',
    s: '1.6rem',
    m: '2.1rem',
    l: '2.4rem',
    xl: '4rem',
  },
};
